/**
 * Footer — CUADRO NEGRO Versión Compatible con DamyxIA.
 *
 * Footer legal global, fijo al fondo del viewport (28px, opacity 0.6,
 * transparente). Compatible con `.App { height: 100dvh; overflow: hidden }`.
 *
 * NO usa fondo opaco, sombras ni logos. Sólo 2 enlaces legales con un
 * separador "·" entre ellos.
 *
 * 🟥 i18n 2026-02-25 — Textos traducidos según `language` del context:
 *   - es: Términos · Privacidad
 *   - en: Terms · Privacy
 */
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

export default function Footer() {
  const { language } = useLanguage();
  const es = language !== 'en';
  return (
    <footer className="legal-footer" data-testid="legal-footer">
      <Link to="/terms" data-testid="footer-terms-link">
        {es ? 'Términos' : 'Terms'}
      </Link>
      <span> · </span>
      <Link to="/privacy" data-testid="footer-privacy-link">
        {es ? 'Privacidad' : 'Privacy'}
      </Link>
    </footer>
  );
}
